import React, { Component } from 'react';
import { Label } from 'reactstrap';
import { observer, inject  } from 'mobx-react';
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import { buscaFiltrarVazio } from './../../../../utils/mensagens';
import LoadingImage from '../../../comum/components/LoadingImage';

@inject("store")
@observer
export class TabelaRelSintetico extends Component {
    
    constructor(props) {
        super(props);

        this.controller = this.props.controller;
    }

    render() {
        if(this.controller.loadingTable) {
            return <LoadingImage />
        } else if(this.controller.listaEntrepostagem.length === 0) {
            return (<div>
                <Label>
                    {buscaFiltrarVazio}
                </Label>
            </div>)
        } else {
            return (<div>
                <ToolkitProvider
                    keyField="ClibrsId"
                    data={[...this.controller.listaEntrepostagem]}
                    columns={[...this.controller.colunas]}
                >
                    {
                        props => (
                            <div>
                                <BootstrapTable bootstrap4
                                    striped
                                    bordered={false}
                                    noDataIndication={"Nenhum registro encontrado."}
                                    classes="tabela tabela-layout"
                                    {...props.baseProps}

                                />
                            </div>
                        )
                    }
                </ToolkitProvider>
            </div>);
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/entrepostagem/relatoriosintetico/components/TabelaRelSintetico.js